import React from 'react';
import { Hero } from './components/Hero';
import { ExtendedTestimonials, StatsAndProof } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2rlys6knvowm5">
      <Hero data-id="element-1" data-mp="2mmcbg18ucy8l" />
      <StatsAndProof data-id="element-2" data-mp="2mmvj8p4s268w" />
      <PainPoints data-id="element-3" data-mp="2mndmw6trrmqu" />
      <ProductOffer data-id="element-4" data-mp="2mjpyfm36lqiz" />
      <Pricing showAnchor data-id="element-5" data-mp="31agnimde2bie" />
      <ExtendedTestimonials data-id="element-6" data-mp="31bs27h8dh3oa" />
      <GuaranteeAndFaq data-id="element-7" data-mp="31c1gw8nyvoeo" />
      <CostSection data-id="element-8" data-mp="31cjjro54x0vk" />
      <Pricing data-id="element-9" data-mp="2wjgqlh49rtfw" />
      <FooterAndProofPopup data-id="element-10" data-mp="2wjql9i09eorx" />
    </main>;
}